import { baseApi } from './baseApi';
import { MerchantGatewayConfig } from './gatewayConfigApi';

export enum PaymentMode {
  NET_BANKING = "NetBanking",
  DEBIT_CARD = "Debit Card",
  UPI = "UPI",
  ENACH = "Enach",
  UPI_AUTOPAY = "UPIAutopay",
  OTM = "OTM",
}

export enum TransactionType {
  LUMPSUM = "Lumpsum",
  EMANDATE = "Emandate",
  HYBRID = "Hybrid",
}

export enum AuthMode {
  NET_BANKING = "Net Banking",
  DEBIT_CARD = "Debit Card",
  UPI = "UPI",
  AADHAR = "Aadhar",
  PAN = "PAN",
}

export interface MerchantConfigWithFrequency extends MerchantGatewayConfig {
  frequency?: number;
  priority?: number;
}

export interface PaymentConfig {
  id: string;
  name: string;
  trtype: TransactionType;
  paymode: PaymentMode;
  authmode: AuthMode;
  asset: { id: string };
  merchantConfigs: MerchantConfigWithFrequency[];
  gatewaySelectionAlgo?: 'Priority' | 'Percentage';
  fundCode?: string;
}

export const paymentConfigApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentConfigs: builder.query<PaymentConfig[], void>({
      query: () => '/pay-config',
      providesTags: ['PaymentConfig'],
    }),

    getPaymentConfigLogsByAsset: builder.query<any, string>({
      query: (assetId) => `/pay-config/logs/${assetId}`,
    }),

    getPaymentConfigsByAsset: builder.query<PaymentConfig[], string>({
      query: (assetId) => `/pay-config/asset/${assetId}`,
      providesTags: (_result, _err, assetId) => [{ type: 'PaymentConfig', id: assetId }],
    }),

    getPaymentConfig: builder.query<PaymentConfig, string>({
      query: (id) => `/pay-config/${id}`,
      providesTags: (_result, _err, id) => [{ type: 'PaymentConfig', id }],
    }),

    createPaymentConfig: builder.mutation<PaymentConfig, Omit<PaymentConfig, 'id'>>({
      query: (config) => ({
        url: '/pay-config',
        method: 'POST',
        body: config,
      }),
      invalidatesTags: ['PaymentConfig'],
    }),

    updatePaymentConfig: builder.mutation<
      PaymentConfig,
      Partial<PaymentConfig> & Pick<PaymentConfig, 'id'>
    >({
      query: ({ id, ...patch }) => ({
        url: `/pay-config/${id}`,
        method: 'PUT',
        body: patch,
      }),
      invalidatesTags: (_result, _err, { id }) => [{ type: 'PaymentConfig', id }],
    }),

    deletePaymentConfig: builder.mutation<void, string>({
      query: (id) => ({
        url: `/pay-config/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PaymentConfig'],
    }),
    // Convert existing static rules to dynamic rules for an AMC
    convertPaymentRules: builder.mutation<void, string>({
      query: (assetId) => ({
        url: `/pay-config/convert/${assetId}`,
        method: 'POST',
      }),
      invalidatesTags: ['PaymentConfig'],
    }),

  }),
});

export const {
  useGetPaymentConfigsQuery,
  useGetPaymentConfigsByAssetQuery,
  useGetPaymentConfigQuery,
  useGetPaymentConfigLogsByAssetQuery,
  useCreatePaymentConfigMutation,
  useUpdatePaymentConfigMutation,
  useDeletePaymentConfigMutation,
  useConvertPaymentRulesMutation,
} = paymentConfigApi;
